import { useEffect, useState } from "react";
import type { StatusGridResponse, StatusSummary } from "../types/status";
import { apiUrl } from "../lib/config";

export function useStatusData(intervalMs = 30_000) {
  const [grid, setGrid] = useState<StatusGridResponse | null>(null);
  const [summary, setSummary] = useState<StatusSummary | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [gridRes, summaryRes] = await Promise.all([
          fetch(apiUrl("/api/v1/status/")),
          fetch(apiUrl("/api/v1/status/summary/")),
        ]);
        if (!gridRes.ok || !summaryRes.ok) {
          throw new Error("API error");
        }
        setGrid(await gridRes.json());
        setSummary(await summaryRes.json());
        setLastUpdated(new Date());
        setError(null);
      } catch {
        setError("Failed to load status data. Retrying...");
      }
    };

    fetchAll();
    const id = setInterval(fetchAll, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return { grid, summary, lastUpdated, error };
}
